import { render, staticRenderFns } from "./MultiStepForm.vue?vue&type=template&id=3bb54585"
import script from "./MultiStepForm.vue?vue&type=script&lang=ts"
export * from "./MultiStepForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports